import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const InvoiceViewContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "InvoiceViewContainer" */
      './InvoiceViewContainer.dynamic'
    ),
  loading: LoadingPageLoadable,
});
